// A "Ducks"-style collection
// https://github.com/erikras/ducks-modular-redux

// Action Types
import { actions } from '../../';
import { scriptTypes } from 'constants/scripts';

// Reducer
export default function reducer(
  state = [],
  action = {}
) {
  switch (action.type) {
    case 'CREATE_PRODUCT':
      const app = state.length ? state[0] : {};
      if (action.payload.applicationType === scriptTypes.APPLICATION) {
        return [{
          ...app,
          product: action.payload.product,
          rate: action.payload.rate
        }];
      } else {
        return [{
          ...app,
          product: action.payload.product,
          'nitrogen-rate': action.payload['nitrogen-rate'],
          rate: action.payload.rate
        }];
      }
    case actions.UPDATE_PRODUCT_APPLICATION_PROPERTY:
      const applicationToUpdate = state.length ? state[0] : {};
      return [Object.assign(applicationToUpdate, action.payload.propertyToUpdate)];

    default:
      return state;
  }
}

// Action Creators
